/**
 * Balão do gráfico de Resultados — mesmo padrão dos relatórios de vendas
 * (fundo do tema, borda e sombra). O balão padrão do recharts é branco e
 * pinta o valor com a cor da linha: os cinzas claros dos anos anteriores
 * sumiam no fundo (pedido do dono, 24/09/2026). Aqui o texto usa a cor do
 * tema e a cor da linha fica só na bolinha ao lado do ano.
 */
export default function BalaoGraficoFiscal({ active, payload, label, formatar }) {
  if (!active || !payload?.length) return null;
  const linhas = [...payload].sort((a, b) => Number(b.name) - Number(a.name));
  return (
    <div className="rounded-lg border bg-popover text-popover-foreground px-3 py-2 text-sm shadow-lg">
      <p className="font-semibold mb-1">{label}</p>
      {linhas.map((l) => (
        <p key={l.name} className="flex items-center gap-2 tabular-nums">
          <span className="inline-block w-2.5 h-2.5 rounded-full shrink-0" style={{ backgroundColor: l.color }} />
          <span className="text-muted-foreground">{l.name}</span>
          <span className="ml-auto pl-3 font-semibold">{formatar(l.value)}</span>
        </p>
      ))}
    </div>
  );
}
